module.exports = __webpack_public_path__ + "static/media/DWFuturaLatinExtA.dabffa8a.woff";